import TableWrappper from "src/pages/reservaciones/inicio/sections/TableWrapper/TableWrapper"
import FlexibleTable, {
    SortFilterValue,
    TableFilter,
} from "src/shared/components/data-display/FlexibleTable/FlexibleTable"
import TablePaginatorWrapper from "src/shared/components/data-display/FlexibleTable/sections/TablePaginatorWrapper/TablePaginatorWrapper"
import FloatButon from "src/shared/components/layout/FloatButon/FloatButon"
import { useFetch } from "src/shared/hooks/useFetch"
import { useProfile } from "src/shared/hooks/useProfile"
import ReportWrapper from "../../components/report-wrapper/ReportWrapper"
import CardReports from "../../components/card-reports/CardReports"
import CardReport, { CardReportDouble } from "../../components/card-report/CardReport"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { tableSkeletonRows } from "src/shared/components/layout/skeleton/TableSkeleton/TableSkeleton"
import {
    FlexibleTableHeaderColumn,
    FlexibleTableRow,
} from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import useFormattedMeta from "../hooks/useFormattedMeta"
import useDedupedRefetch from "../hooks/useDedupedRefetch"
import { useEffect, useMemo, useState } from "react"
import useDownloadPdf from "src/shared/hooks/useDownloadPdf"
import { Stringify } from "src/shared/types/Stringify"
import { HistorialVentasYReservas, TablaVentasReserva } from "./VentasYReservas.type"
import useOrigenHeader from "./hooks/useOrigenHeader"
import useHabitacionesHeader from "../hooks/useHabitacionesHeader"
import useMovimientoHeader from "./hooks/useMovimientoHeader"
import useTurnoHeader from "../hooks/useTurnoHeader"
import useColaboradoresHeader from "../hooks/useColaboradoresHeader"
import { formatTextWithCapitalize } from "src/shared/hooks/formatTextOpcions"
import { splitBySlash } from "src/shared/helpers/splitBySlash"
import { formatTipoPago } from "src/shared/helpers/formatTipoPago"
import { capitalize } from "src/shared/helpers/capitalize"
import reportSelectedHandler from "../../helpers/reportSelectedHandler"
import { ReportsOptions } from "../../Reports.type"
import ReportLoaderModal from "../../components/report-loader/ReportLoaderModal"
import useMetodoPagoHeader from "../hooks/useMetodoPagoHeader"
import VentasReservasDetail from "./detail/VentasReservasDetail"
import useVentasReservasDetail from "./detail/hooks/useVentasReservasDetail"

const VentasReservas = ({ apiDateFilter }: { apiDateFilter: string[] | null }) => {
    const { hotel_id } = useProfile()
    const { download } = useDownloadPdf()

    const { data, refetch, load } = useFetch<HistorialVentasYReservas>("/reportes/tabla_estancia_reservas", {
        startFetch: false,
    })

    const [currentPage, setcurrentPage] = useState(1)

    const origenHeader = useOrigenHeader<Stringify<TablaVentasReserva>>({
        headerValue: "origen",
        valueToDisplay: "Origen",
    })

    const habitacionHeader = useHabitacionesHeader<Stringify<TablaVentasReserva>>({
        headerValue: "habitacion",
        valueToDisplay: "Habitación",
    })

    const responsableHeader = useColaboradoresHeader<Stringify<TablaVentasReserva>>({
        headerValue: "atiende",
        valueToDisplay: "Atendió",
    })

    const cobraHeader = useColaboradoresHeader<Stringify<TablaVentasReserva>>({
        headerValue: "cobra",
        valueToDisplay: "Cobró",
    })

    const movimientoHeader = useMovimientoHeader<Stringify<TablaVentasReserva>>({
        headerValue: "categoria",
        valueToDisplay: "Categoría",
    })

    const turnoHeader = useTurnoHeader<Stringify<TablaVentasReserva>>({
        headerValue: "turno",
        valueToDisplay: "Turno",
    })

    const metodosPagosHeader = useMetodoPagoHeader<Stringify<TablaVentasReserva>>({
        headerValue: "metodos_pago",
        valueToDisplay: "Método de pago",
    })

    const [sortValue, setsortValue] = useState<SortFilterValue | null>(null)
    const [filterValues, setfilterValues] = useState<TableFilter[] | null>(null)

    const formattedMetaValues = useMemo<{
        filterValues: TableFilter[] | null
        sortValue: SortFilterValue | null
        headerValues: Stringify<TablaVentasReserva>[]
    }>(
        () => ({
            filterValues,
            sortValue,
            headerValues: [
                "ticket",
                "origen",
                "categoria",
                "habitacion",
                "total",
                "metodos_pago",
                "fecha",
                "turno",
                "atiende",
                "cobra",
                "hotel",],
        }),
        [filterValues, sortValue]
    )

    const { formattedMeta } = useFormattedMeta(formattedMetaValues)

    useDedupedRefetch(
        refetch,
        apiDateFilter && {
            hotel_id,
            fecha_inicio: apiDateFilter[0],
            fecha_fin: apiDateFilter[1],
            take: 15,
            page: currentPage,
            ...(formattedMeta?.filtro ? { filtro: JSON.stringify(formattedMeta.filtro) } : {}),
            ...(formattedMeta?.orden ? { orden: JSON.stringify(formattedMeta.orden) } : {}),
        }
    )

    const headers: FlexibleTableHeaderColumn[] = [
        { value: "Ticket" },
        origenHeader,
        movimientoHeader,
        habitacionHeader,
        { value: "total", valueToDisplay: "Total", sort: true },
        metodosPagosHeader,
        { value: "fecha", valueToDisplay: "Fecha", sort: true },
        turnoHeader,
        responsableHeader,
        cobraHeader,
    ]

    const { skeletonRows } = tableSkeletonRows({ headers })

    const rows = data?.respuesta.tabla_ventas_reservas

    const { selectedRow, isOpen, openDetail, closeDetail } = useVentasReservasDetail(rows)

    const tableItems: FlexibleTableRow[] = rows?.map((hab, index) => ({
        // goTo lo recibe el evento goTo de la tabla al dar click en la fila, se usa para abrir el detalle
        goTo: String(index),
        className: "ventas-reservas__row--clickable",
        value: [
            { value: hab.ticket, className: "reports-cell" },
            { value: capitalize(hab.origen), className: "reports-cell" },
            { value: formatTextWithCapitalize(hab.categoria), className: "reports-cell" },
            { value: hab.habitacion, className: "reports-cell" },
            { value: formatCurrencyToFixed(hab.total), className: "reports-cell" },
            {
                value: (() => {
                    const payments = splitBySlash(hab.metodos_pago || "")
                    return (
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <span>{payments.length > 1 ? "Mixto" : formatTipoPago(payments[0]?.[0]) || "N/A"}</span>
                            {(payments.length > 1 || !!payments[0]?.[1]) && (
                                <div style={{ display: "flex", flexWrap: "wrap" }}>
                                    {payments.map((p, index) => (
                                        <span key={index} style={{ color: "var(--placeholder)" }}>
                                            {p[1] ?? p[0]}
                                            {index < payments.length - 1 ? ", " : ""}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    )
                })(),
                className: "reports-cell",
            },
            { value: hab.fecha, className: "reports-cell" },
            { value: hab.turno, className: "reports-cell" },
            { value: hab.atiende, className: "reports-cell" },
            { value: hab.cobra, className: "reports-cell" },
        ],
    }))

    const { setSelectedSection } = reportSelectedHandler()

    useEffect(() => {
        setSelectedSection(ReportsOptions.ventasHabYReservas)
    }, [])

    useEffect(() => {
        setcurrentPage(1)
    }, [apiDateFilter])

    return (
        <>
            {load &&
                <ReportLoaderModal isOpen />
            }
            <ReportWrapper height="calc(100dvh - 125px)">
                <CardReports>
                    <CardReport 
                        title="Total de estancia" 
                        value={formatCurrencyToFixed(data?.dashboard.total_estancia || 0)}
                    />
                    <CardReportDouble 
                        title1="Total de rentas"
                        value1={formatCurrencyToFixed(data?.dashboard?.venta_habitaciones || 0)}
                        subTitle1="Total"
                        subValue1={data?.dashboard?.cantidad_habitaciones || 0}
                        title2="Total de reservas"
                        value2={formatCurrencyToFixed(data?.dashboard?.venta_reservas || 0)}
                        subTitle2="Total"
                        subValue2={data?.dashboard?.cantidad_reservas || 0}
                    />
                    <CardReportDouble 
                        title1="Check-in anticipado"
                        value1={formatCurrencyToFixed(data?.dashboard?.venta_early_checkin || 0)}
                        subTitle1="Total"
                        subValue1={data?.dashboard?.cantidad_early_checkin || 0}
                        title2="Hospedajes extra"
                        value2={formatCurrencyToFixed(data?.dashboard?.venta_hospedaje_extra || 0)}
                        subTitle2="Total"
                        subValue2={data?.dashboard?.cantidad_hospedaje_extra || 0}
                    />
                    <CardReportDouble 
                        title1="Horas extra"
                        value1={formatCurrencyToFixed(data?.dashboard?.venta_horas_extras || 0)}
                        subTitle1="Total"
                        subValue1={data?.dashboard?.cantidad_horas_extras || 0}
                        title2="Personas extra"
                        value2={formatCurrencyToFixed(data?.dashboard?.venta_personas_extra || 0)}
                        subTitle2="Total"
                        subValue2={data?.dashboard?.cantidad_personas_extra || 0}
                    />
                </CardReports>
                <TablePaginatorWrapper
                    className="historial-propinas__table__wrapper"
                    currentPage={currentPage}
                    onChange={(p) => setcurrentPage(p)}
                    pages={data?.respuesta.total_paginas || 0}
                    style={{
                        justifyContent: data?.respuesta?.tabla_ventas_reservas?.length ? "flex-start" : "center",
                        borderRadius: "0 0 20px 0",
                    }}
                >
                    <TableWrappper>
                        <FlexibleTable
                            goTo={(rowKey) => {
                                if (load) {
                                    return
                                }
                                openDetail(rowKey)
                            }}
                            containerStyle={{
                                ...(load ? { overflow: "hidden" } : {})
                            }}
                            emptyState={{
                                headerIcon: "PieChartFilled",
                                titile: "Aún no hay reportes disponibles",
                                subTitle:
                                    "Todavía no hay datos para mostrar en esta sección. Una vez que se genere un reporte, lo verás aquí.",
                            }}
                            onSelectedFilters={(v) => {
                                setcurrentPage(1)
                                setfilterValues(v)
                            }}
                            onSort={(v) => {
                                setcurrentPage(1)
                                setsortValue(v)
                            }}
                            containterClassName="historial-propinas__table"
                            tableItems={{
                                headers,
                                rows: load ? skeletonRows : tableItems,
                            }}
                        />
                    </TableWrappper>
                    <FloatButon
                        icon="Download"
                        onAdd={() => {
                            if (!apiDateFilter?.length) {
                                return
                            }
                            download({
                                endpoint: "/reportes/tabla_estancia_reservas",
                                params: {
                                    hotel_id,
                                    fecha_inicio: apiDateFilter[0],
                                    fecha_fin: apiDateFilter[1],
                                    descargar: true,
                                    ...(formattedMeta?.filtro ? { filtro: JSON.stringify(formattedMeta.filtro) } : {}),
                                    ...(formattedMeta?.orden ? { orden: JSON.stringify(formattedMeta.orden) } : {})
                                },
                                title: "ventas_reservas",
                            })
                        }}
                    />
                </TablePaginatorWrapper>
            </ReportWrapper>
            <VentasReservasDetail isOpen={isOpen} onClose={closeDetail} data={selectedRow} />
        </>
    )
}

export default VentasReservas

